var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDistributioCenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.75 49.5V38.25C60.7486 37.0569 60.2741 35.9132 59.4305 35.0695C58.5869 34.2259 57.4431 33.7514 56.25 33.75H38.25V22.5H45C46.1931 22.4986 47.3369 22.0241 48.1805 21.1805C49.0241 20.3369 49.4986 19.1931 49.5 18V9C49.4986 7.80695 49.0241 6.66315 48.1805 5.81953C47.3369 4.97592 46.1931 4.50137 45 4.5H27C25.8069 4.50137 24.6632 4.97592 23.8195 5.81953C22.9759 6.66315 22.5014 7.80695 22.5 9V18C22.5014 19.1931 22.9759 20.3369 23.8195 21.1805C24.6632 22.0241 25.8069 22.4986 27 22.5H33.75V33.75H15.75C14.5569 33.7514 13.4131 34.2259 12.5695 35.0695C11.7259 35.9132 11.2514 37.0569 11.25 38.25V49.5H4.5V67.5H22.5V49.5H15.75V38.25H33.75V49.5H27V67.5H45V49.5H38.25V38.25H56.25V49.5H49.5V67.5H67.5V49.5H60.75ZM27 9H45V18H27V9ZM18 63H9V54H18V63ZM40.5 63H31.5V54H40.5V63ZM63 63H54V54H63V63Z",
    fill: "#161616"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDistributioCenter);
export default __webpack_public_path__ + "static/media/ic-distributio-center.fab5e1ae9767d81c2ce61685c7db0f74.svg";
export { ForwardRef as ReactComponent };